import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const orderService = {
  // Customer: Create order
  async createOrder(orderData) {
    const response = await api.post('/orders', orderData);
    return response.data;
  },

  // Customer: Get my orders
  async getMyOrders() {
    const response = await api.get('/orders/customer/my');
    return response.data;
  },

  // Customer: Track order
  async trackOrder(orderId) {
    const response = await api.get(`/orders/customer/${orderId}`);
    return response.data;
  },

  // Customer: Upload payment receipt
  async uploadPaymentReceipt(orderId, receiptFile) {
    const formData = new FormData();
    formData.append('receipt', receiptFile);

    const response = await api.put(`/orders/customer/${orderId}/receipt`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Customer: Confirm delivery
  async confirmDelivery(orderId) {
    const response = await api.put(`/orders/customer/${orderId}/confirm-delivery`);
    return response.data;
  },

  // Pharmacy: Get pharmacy orders
  async getPharmacyOrders() {
    const response = await api.get('/orders/pharmacy/my');
    return response.data;
  },

  // Pharmacy: Update order status
  async updateOrderStatus(orderId, status) {
    const response = await api.put(`/orders/pharmacy/${orderId}/status`, { status });
    return response.data;
  },

  // Pharmacy: Confirm payment
  async confirmPayment(orderId, receiptFile = null) {
    const formData = new FormData();
    if (receiptFile) {
      formData.append('receipt', receiptFile);
    }

    const response = await api.put(`/orders/pharmacy/${orderId}/payment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Pharmacy: Assign order to rider
  async assignOrderToRider(orderId, riderId) {
    const response = await api.post('/orders/pharmacy/assign', {
      orderId,
      riderId
    });
    return response.data;
  },

  // Rider: Get available orders
  async getAvailableOrders() {
    const response = await api.get('/orders/rider/available');
    return response.data;
  },

  // Rider: Accept order
  async acceptOrder(orderId) {
    const response = await api.put(`/orders/rider/${orderId}/accept`);
    return response.data;
  },

  // Rider: Update order status
  async updateOrderStatusRider(orderId, status, coordinates = null) {
    const response = await api.put(`/orders/rider/${orderId}/status`, {
      status,
      coordinates
    });
    return response.data;
  },

  // Rider: Get my orders
  async getRiderOrders() {
    const response = await api.get('/orders/rider/my');
    return response.data;
  },

  // Get order statistics
  async getOrderStats() {
    const response = await api.get('/orders/stats/overview');
    return response.data;
  }
};

export default orderService;
